import { memo, Suspense } from 'react';
import { BreadcrumbsProvider } from '@dfl/mui-admin-layout';
import { PageLoader } from '@dfl/mui-react-common';
import { RouteLoader } from '@dfl/react-security';
import { routes } from './main.routes';

const Routes = () => {
  return (
    <Suspense fallback={<PageLoader size={'screen'} />}>
      <BreadcrumbsProvider>
        <RouteLoader routes={routes} />
      </BreadcrumbsProvider>
    </Suspense>
  );
};

export default memo(Routes);
